export default __webpack_public_path__ + "assets/images/aba12ff5909693d18780aa97a8e9cf96.png";